import { useEffect, ReactElement, useState } from 'react';

import { initFrontChat } from '../../modules/frontChat';

export function FrontChat(): ReactElement | null {
  const chatId = process.env.REACT_APP_FRONT_CHAT_ID;
  const [hasInitialized, setHasInitialized] = useState(false);

  // Handle Front Chat initialization and user updates
  useEffect(() => {
    // Don't do anything if no chat ID is configured or user is loading
    if (!chatId) {
      return;
    }

    const handleFrontChat = async () => {
      // Initialize Front Chat

      if (
        !hasInitialized &&
        typeof window !== 'undefined' &&
        window.FrontChat
      ) {
        initFrontChat();
        setHasInitialized(true);
      }
    };

    handleFrontChat();
  }, [chatId, hasInitialized]);

  return null;
}
